import { of } from 'rxjs';
import { tap, ignoreElements } from 'rxjs/operators';
import { combineEpics, ofType } from 'redux-observable';
import { getCompletedAsyncWrapperObj } from '@ane/core/lib/models';
import { produceLoadLoadingLoadedEpic } from '@ane/core/lib/utils/ReduxObservablesEpicUtils';
import NavigationService from '@ane/core/lib/services/NavigationService';
import { createDataSourceOverrideActionTypes, creatingDataSource, createdDataSource, updateDataSourceOverrideActionTypes, updatingDataSource, updatedDataSource, } from './DataSourceCreateContainer.ducks';
import DataSourceResource from '../../../../DataSource.resource';
import { convertToOverridePostParams } from '../CreateWizard/DataSourceCreateFormSettings';
import { DataSourceRouteUtils } from '@ane/exp-data/lib/routes/DataSourceRoute.utils';
export const createDataSourceEpic = produceLoadLoadingLoadedEpic({
    filterOnType: createDataSourceOverrideActionTypes.LOAD,
    loadResource: (payload) => {
        let dataSourcePost = convertToOverridePostParams(payload);
        return DataSourceResource.postDataSource(dataSourcePost);
    },
    loadingAction: (payload) => creatingDataSource(),
    loadedAction: (successData, payload, error) => {
        return of(createdDataSource(getCompletedAsyncWrapperObj(successData, error)));
    },
});
export const updateDataSourceEpic = produceLoadLoadingLoadedEpic({
    filterOnType: updateDataSourceOverrideActionTypes.LOAD,
    loadResource: (payload) => {
        var _a, _b;
        let dataSourcePost = convertToOverridePostParams(payload);
        return DataSourceResource.putDataSource(dataSourcePost, (_b = (_a = payload.dataSourceItem) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.Version);
    },
    loadingAction: (payload) => updatingDataSource(),
    loadedAction: (successData, payload, error) => {
        return of(updatedDataSource(getCompletedAsyncWrapperObj(successData, error)));
    },
});
export const afterCreateDataSource = (action$) => {
    return action$.pipe(ofType(createDataSourceOverrideActionTypes.LOADED), tap((action) => {
        let postParams = action.payload.createDataSource.data;
        if (!!postParams && !!postParams.OverrideInfo && postParams.OverrideInfo.OverrideFrom.DataSourceName) {
            NavigationService.navigateTo(DataSourceRouteUtils.routes.view.getURL({
                id: postParams.OverrideInfo.OverrideFrom.DataSourceName,
                pivot: 'override',
            }));
        }
    }), ignoreElements());
};
export default combineEpics(createDataSourceEpic, afterCreateDataSource, updateDataSourceEpic);

//# sourceMappingURL=DataSourceCreateContainer.epic.js.map
